<template>
    <div>
        <vs-input :disabled="disabled" :placeholder="placeholder" :danger="danger" type="text" class="w-full" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true"/>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: [String,Number],
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: ''
            },
            danger: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isInputActive: false
            }
        },
        computed: {
            displayValue: {
                get: function() {
                    if (this.value == null) {
                        return "";
                    }
                    let newVal = this.value || 0;
                    if (this.isInputActive) {
                        // Cursor is inside the input field. unformat display value for user
                        return newVal.toString()
                    } else {
                        if(parseFloat(newVal) % 1 === 0) {
                            return parseFloat(newVal).toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
                        } else {
                            console.log("masuk");
                            return newVal.toString().replace(/\./g, ',');
                        }
                    }
                },
                set: function(modifiedValue) {
                    // Recalculate value after ignoring "$" and "," in user input
                    let newValue = parseFloat(modifiedValue.replace(/\-[^\d\.]/g, ""))
                    // Ensure that it is not NaN
                    if (isNaN(newValue)) {
                        newValue = 0
                    }
                    // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                    // $emit the event so that parent component gets it
                    this.$emit('input', newValue)
                }
            }
        }
    }
</script>
